import CircularLoadingDots from "components/utils/CircularLoadingDots";
import { motion } from "framer-motion";
import {
  defaultBgVariants,
  defaultPanelVariants,
} from "../common/defaultValues";

interface SavingPopUpProps {
  title?: string;
  description?: string;
  onBgClick?: () => void;
}

const SavingPopUp: React.FC<SavingPopUpProps> = ({
  title = "Creation in Progress",
  description = "Please wait while we process this request...",
  onBgClick = () => {},
}) => {
  return (
    <>
      <motion.div
        key="saving-blurred-background"
        className="fixed inset-0 w-full h-full bg-neutral-500 bg-opacity-40 backdrop-blur-[2px] z-20 flex flex-col flex-grow"
        variants={defaultBgVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.1, ease: "easeOut" }}
        onClick={onBgClick}
      />
      <motion.div
        key="add-contact"
        className="fixed w-[462px] h-fit left-0 right-0 ml-auto mr-auto bottom-5 p-6 pb-12 bg-white rounded-3xl flex-col justify-start items-start gap-6 inline-flex z-30 ease-in-out duration-150"
        variants={defaultPanelVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.1, ease: "easeOut" }}
      >
        <div
          key="loading"
          className="inline-flex w-full max-h-[80vh] flex-col flex-1 justify-start items-center gap-10 overflow-y-auto custom-scroll"
        >
          <div className="self-stretch px-3.5 py-4 justify-center items-center inline-flex">
            <CircularLoadingDots nDots={10} className="relative w-32 h-32" />
          </div>
          <div className="w-full h-fit flex-col justify-start items-start gap-6 flex">
            <div className="self-stretch h-fit flex-col justify-start items-start gap-6 flex">
              <div className="self-stretch text-neutral-700 text-[23px] leading-7 font-semibold font-sans justify-start select-none">
                {title}
              </div>
              <div className="self-stretch text-neutral-700 text-base font-normal font-sans leading-7 select-none">
                {description}
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default SavingPopUp;
